export const symbolsHeaderId = 'symbols-pane-header'
export const textAreaId = 'read-only-cursor-text-area'
